import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

Sentry.init({
	dsn: 'https://a54d598bd1834bd889b2145fb8d3e283@sentry.io/1254450',
	allowUrls: [/https?:\/\/((www)\.)?aplace\.com/],
	ignoreErrors: ['Non-Error promise rejection captured'],
});

hydrate();
